import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

import Login from "../views/Login.vue";
import GoodDay from "../views/GoodDay.vue";
import CreateAccount from "../views/CreateAccount.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Welcome from "../views/Welcome.vue";
import InfoCentre from "../views/InfoCentre.vue";
import Feedback from "../views/Feedback.vue";
import WifiStatus from "../views/WifiStatus.vue";
import FeedbackSubmitted from "../views/FeedbackSuccess.vue";
import Contact from "../views/Contact.vue";
import PowerOnSolshare from "../views/PowerOnSolshare.vue";
import HowToEnterSerialNumber from "../views/SerialNumberHow.vue";
import SerialNumberManually from "../views/SerialNumberManually.vue";
import SerialNumberQRCode from "../views/SerialNumberQRCode.vue";
import SearchingSolshare from "../views/SearchingSolshare.vue";
import SearchingSolshareFailedOffline from "../views/SearchingSolshareFailedOffline.vue";
import SearchingSolshareNotFound from "../views/SearchingSolshareFailedNotFound.vue";
import SearchingSolshareFailedNeedPowerCycle from "../views/SearchingSolshareFailedNeedPowerCycle.vue";
import SearchingSolshareAlready from "../views/SearchingSolshareAlready.vue";
import SearchingSolshareSuccess from "../views/SearchingSolshareSuccess.vue";
import AddASite from "../views/AddASite.vue";
import AddWarrantyInfo from "../views/AddWarrantyInfo.vue";
import SystemSpecifications from "../views/SystemSpecifications.vue";
import SolshareConnectedToInverter from "../views/SolshareConnectedToInverter.vue";
import PhaseTypeChoose from "../views/PhaseTypeChoose.vue";
import PhaseTypeSingle from "../views/PhaseTypeSingle.vue";
import PhaseTypeTriple from "../views/PhaseTypeTriple.vue";
import PhaseTypeReview from "../views/PhaseTypeReview.vue";
import PhaseTypeReviewEdit from "../views/PhaseTypeReviewEdit.vue";
import SolarDeliveryMethod from "../views/SolarDeliveryMethod.vue";
import SolarDeliveryMethodUnsure from "../views/SolarDeliveryMethodUnsure.vue";
import CTRating from "../views/CTRating.vue";
import CTRatingUnsure from "../views/CTRatingUnsure.vue";
import CommissionSolshare from "../views/CommissionSolshare.vue";
import CommissionSolshareInProgress from "../views/CommissionSolshareInProgress.vue";
import CommissionSolshareFailed from "../views/CommissionSolshareFailed.vue";
import CommissionSolshareSuccess from "../views/CommissionSolshareSuccess.vue";
import Congratulations from "../views/Congratulations.vue";
import Error from "../views/Error.vue";
import CreateAccountConfirmed from "../views/CreateAccountConfirmd";
import UnequalAllocation from "../views/UnequalAllocation";
import UnequalAllocationReview from "../views/UnequalAllocationReview";
import NetPromoterScore from "../views/NetPromoterScore";
import SystemInfo from "../views/SystemInfo";
import SolsharesAtSite from "../views/SolsharesAtSite";
import SystemBuildingAddressEdit from "../views/SystemBuildingAddressEdit";
import FaultStatus from "../views/FaultStatus";
import SolarDeliveryMethodEdit from "../views/SolarDeliveryMethodEdit";
import SystemBuildingAddressView from "../views/SystemBuildingAddressView";
import SolarDeliveryMethodView from "../views/SolarDeliveryMethodView";
import PhaseTypeReviewEditServiceInterface from "../views/PhaseTypeReviewEditServiceInterface";
import PhaseTypeReviewServiceInterface from "../views/PhaseTypeReviewServiceInterface";
import SoftwareUpdate from "../views/SoftwareUpdate";
import SoftwareUpdateSuccess from "../views/SoftwareUpdateSuccess";
import SoftwareUpdateFailed from "../views/SoftwareUpdateFailed";
import SoftwareUpdateUnsupported from "../views/SoftwareUpdateUnsupported";
import ViewFleet from "../views/ViewFleet";
import AccessControl from "../views/AccessControl";
import MySites from "../views/MySites.vue";
import SoftwareUpdateInstruction from "../views/SoftwareUpdateInstruction.vue";
import PhaseToPhaseAU from "../views/Error/Gen2/PhaseToPhase/PhaseToPhase.AU.2.vue";
import PhaseToPhaseUK from "../views/Error/Gen2/PhaseToPhase/PhaseToPhase.UK.2.vue";
import NoVoltageReferenceAU from "../views/Error/Gen1-and-2/NoVoltageReference/NoVoltageReference.AU.2.vue";
import NoVoltageReferenceUK from "../views/Error/Gen2/NoVoltageReference/NoVoltageReference.UK.2.vue";
import ReversedCTAU1 from "../views/Error/Gen1-and-2/CTErrors/ReversedCT/ReversedCT.AU.1.vue";
import ReversedCTAU2 from "../views/Error/Gen1-and-2/CTErrors/ReversedCT/ReversedCT.AU.2.vue";
import ReversedCTAU3 from "../views/Error/Gen1-and-2/CTErrors/ReversedCT/ReversedCT.AU.3.vue";
import ReversedCTUK1 from "../views/Error/Gen1-and-2/CTErrors/ReversedCT/ReversedCT.UK.1.vue";
import ReversedCTUK2 from "../views/Error/Gen1-and-2/CTErrors/ReversedCT/ReversedCT.UK.2.vue";
import ReversedCTUK3 from "../views/Error/Gen1-and-2/CTErrors/ReversedCT/ReversedCT.UK.3.vue";
import CTNotReadingAU1 from "../views/Error/Gen1-and-2/CTErrors/CTNotReading/CTNotReading.AU.1.vue";
import CTNotReadingAU2 from "../views/Error/Gen1-and-2/CTErrors/CTNotReading/CTNotReading.AU.2.vue";
import CTNotReadingAU3 from "../views/Error/Gen1-and-2/CTErrors/CTNotReading/CTNotReading.AU.3.vue";
import CTNotReadingAU4 from "../views/Error/Gen1-and-2/CTErrors/CTNotReading/CTNotReading.AU.4.vue";
import CTNotReadingUK1 from "../views/Error/Gen1-and-2/CTErrors/CTNotReading/CTNotReading.UK.1.vue";
import CTNotReadingUK2 from "../views/Error/Gen1-and-2/CTErrors/CTNotReading/CTNotReading.UK.2.vue";
import CTNotReadingUK3 from "../views/Error/Gen1-and-2/CTErrors/CTNotReading/CTNotReading.UK.3.vue";
import CTNotReadingUK4 from "../views/Error/Gen1-and-2/CTErrors/CTNotReading/CTNotReading.UK.4.vue";
import CTNotReadingUK5 from "../views/Error/Gen1-and-2/CTErrors/CTNotReading/CTNotReading.UK.5.vue";
import CTReadingIncorrectAU1 from "../views/Error/Gen1-and-2/CTErrors/CTReadingIncorrect/CTReadingIncorrect.AU.1.vue";
import CTReadingIncorrectAU2 from "../views/Error/Gen1-and-2/CTErrors/CTReadingIncorrect/CTReadingIncorrect.AU.2.vue";
import CTReadingIncorrectAU3 from "../views/Error/Gen1-and-2/CTErrors/CTReadingIncorrect/CTReadingIncorrect.AU.3.vue";
import CTReadingIncorrectAU4 from "../views/Error/Gen1-and-2/CTErrors/CTReadingIncorrect/CTReadingIncorrect.AU.4.vue";
import CTReadingIncorrectAU5 from "../views/Error/Gen1-and-2/CTErrors/CTReadingIncorrect/CTReadingIncorrect.AU.5.vue";
import CTReadingIncorrectUK1 from "../views/Error/Gen1-and-2/CTErrors/CTReadingIncorrect/CTReadingIncorrect.UK.1.vue";
import CTReadingIncorrectUK2 from "../views/Error/Gen1-and-2/CTErrors/CTReadingIncorrect/CTReadingIncorrect.UK.2.vue";
import CTReadingIncorrectUK3 from "../views/Error/Gen1-and-2/CTErrors/CTReadingIncorrect/CTReadingIncorrect.UK.3.vue";
import CTReadingIncorrectUK4 from "../views/Error/Gen1-and-2/CTErrors/CTReadingIncorrect/CTReadingIncorrect.UK.4.vue";
import ConfirmTraining from "../views/ConfirmTraining.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: GoodDay,
  },
  {
    path: "/feedback/1",
    component: Feedback,
    meta: { requiresAuth: true, showWifiIcon: true },
  },
  {
    path: "/feedback/2",
    component: FeedbackSubmitted,
    meta: { requiresAuth: true, showWifiIcon: true },
  },
  {
    path: "/contact",
    component: Contact,
    meta: { showWifiIcon: true },
  },
  {
    path: "/wifi-status",
    component: WifiStatus,
    meta: { requiresAuth: true, showWifiIcon: true },
  },
  {
    path: "/login",
    component: Login,
    beforeEnter: (to, from, next) => {
      if (store.getters.isLoggedIn) {
        next("/welcome");
      } else {
        next();
      }
    },
  },
  {
    path: "/create-account",
    component: CreateAccount,
  },
  {
    path: "/account-created",
    component: CreateAccountConfirmed,
  },
  {
    path: "/reset-password/:token",
    component: ResetPassword,
  },
  {
    path: "/welcome",
    component: Welcome,
    meta: { requiresAuth: true },
  },
  {
    path: "/info-centre",
    component: InfoCentre,
  },
  {
    path: "/confirm-training",
    component: ConfirmTraining,
    meta: { requiresAuth: true, showWifiIcon: true },
  },
  {
    path: "/commission/1",
    component: PowerOnSolshare,
    meta: { requiresAuth: true },
  },
  {
    path: "/my-sites",
    component: MySites,
    meta: { requiresAuth: true },
  },
  {
    path: "/add-a-site",
    component: AddASite,
    meta: { requiresAuth: true },
  },
  {
    path: "/add-warranty-info",
    component: AddWarrantyInfo,
    meta: { requiresAuth: true },
  },
  {
    path: "/commission/2",
    component: HowToEnterSerialNumber,
    meta: { requiresAuth: true },
  },
  {
    path: "/wifi-enter-serial",
    component: SerialNumberManually,
    props: { nextAction: "wifiStatus" },
    meta: { requiresAuth: true },
  },
  {
    path: "/reconfigure-enter-serial",
    component: SerialNumberManually,
    props: { nextAction: "getSystemInfo" },
    meta: { requiresAuth: true },
  },
  {
    path: "/commission/3",
    component: SerialNumberManually,
    props: { nextAction: "searchMeter" },
    meta: { requiresAuth: true },
  },
  {
    path: "/commission/4",
    component: SerialNumberQRCode,
    meta: { requiresAuth: true },
  },
  {
    path: "/commission/5",
    component: SearchingSolshare,
    meta: {
      requiresAuth: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.path === "/error") {
        next("/commission/2");
      } else {
        next();
      }
    },
  },
  {
    path: "/commission/6/1",
    component: SearchingSolshareFailedOffline,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/6/2",
    component: SearchingSolshareNotFound,
    meta: {
      requiresAuth: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/6/3",
    component: SearchingSolshareFailedNeedPowerCycle,
    meta: {
      requiresAuth: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/7",
    component: SearchingSolshareAlready,
    meta: {
      requiresAuth: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/8",
    component: SearchingSolshareSuccess,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/software-update-instruction",
    component: SoftwareUpdateInstruction,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/software-update",
    component: SoftwareUpdate,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/software-update-success",
    component: SoftwareUpdateSuccess,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/software-update-failed",
    component: SoftwareUpdateFailed,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/software-update-unsupported",
    component: SoftwareUpdateUnsupported,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/10",
    component: SystemSpecifications,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/11",
    component: SolshareConnectedToInverter,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/12/:index",
    component: PhaseTypeChoose,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/13/:index",
    component: PhaseTypeTriple,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/14/:index",
    component: PhaseTypeSingle,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/15",
    component: PhaseTypeReview,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/view-connected-units",
    component: PhaseTypeReviewServiceInterface,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/16",
    component: PhaseTypeReviewEdit,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/edit-connected-units",
    component: PhaseTypeReviewEditServiceInterface,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/17",
    component: SolarDeliveryMethod,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/18",
    component: SolarDeliveryMethodUnsure,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/ct-rating",
    component: CTRating,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/ct-rating-unsure",
    component: CTRatingUnsure,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/19",
    component: CommissionSolshare,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/20",
    component: CommissionSolshareFailed,
    meta: {
      requiresAuth: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/21",
    component: CommissionSolshareInProgress,
    meta: {
      requiresAuth: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.path === "/error") {
        next("/commission/19");
      } else {
        next();
      }
    },
  },
  {
    path: "/net-promoter-score",
    component: NetPromoterScore,
    meta: {
      requiresAuth: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/22",
    component: CommissionSolshareSuccess,
    meta: {
      requiresAuth: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/unequal-allocation/:index",
    component: UnequalAllocation,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/commission/unequal-allocation-review",
    component: UnequalAllocationReview,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
      requiresAddress: true,
    },
  },
  {
    path: "/congratulations",
    component: Congratulations,
    meta: { requiresAuth: true },
  },
  {
    path: "/system-info",
    component: SystemInfo,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/solshares-at-site",
    component: SolsharesAtSite,
    meta: { requiresAuth: true },
  },
  {
    path: "/view-building-address",
    component: SystemBuildingAddressView,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
    },
  },
  {
    path: "/edit-building-address",
    component: SystemBuildingAddressEdit,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
    },
  },
  {
    path: "/fault-status",
    component: FaultStatus,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
    },
  },
  {
    path: "/view-solar-deliver-method",
    component: SolarDeliveryMethodView,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
    },
  },
  {
    path: "/edit-solar-deliver-method",
    component: SolarDeliveryMethodEdit,
    meta: {
      requiresAuth: true,
      showWifiIcon: true,
      requiresSerialNumber: true,
    },
  },
  {
    path: "/view-fleet",
    component: ViewFleet,
    meta: { requiresAuth: true },
  },
  {
    path: "/access-control",
    component: AccessControl,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/reset-connections",
    component: PhaseTypeReviewEdit,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/error",
    component: Error,
  },
  {
    path: "/commission/error/phase-to-phase-au",
    component: PhaseToPhaseAU,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/phase-to-phase-uk",
    component: PhaseToPhaseUK,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/no-voltage-au",
    component: NoVoltageReferenceAU,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/no-voltage-uk",
    component: NoVoltageReferenceUK,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/reversed-ct-au/1",
    component: ReversedCTAU1,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/reversed-ct-au/2",
    component: ReversedCTAU2,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/reversed-ct-au/3",
    component: ReversedCTAU3,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/reversed-ct-uk/1",
    component: ReversedCTUK1,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/reversed-ct-uk/2",
    component: ReversedCTUK2,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/reversed-ct-uk/3",
    component: ReversedCTUK3,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },

  {
    path: "/commission/error/ct-not-reading-au/1",
    component: CTNotReadingAU1,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-not-reading-au/2",
    component: CTNotReadingAU2,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-not-reading-au/3",
    component: CTNotReadingAU3,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-not-reading-au/4",
    component: CTNotReadingAU4,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-not-reading-uk/1",
    component: CTNotReadingUK1,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-not-reading-uk/2",
    component: CTNotReadingUK2,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-not-reading-uk/3",
    component: CTNotReadingUK3,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-not-reading-uk/4",
    component: CTNotReadingUK4,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-not-reading-uk/5",
    component: CTNotReadingUK5,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-reading-incorrect-au/1",
    component: CTReadingIncorrectAU1,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-reading-incorrect-au/2",
    component: CTReadingIncorrectAU2,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-reading-incorrect-au/3",
    component: CTReadingIncorrectAU3,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-reading-incorrect-au/4",
    component: CTReadingIncorrectAU4,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-reading-incorrect-au/5",
    component: CTReadingIncorrectAU5,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-reading-incorrect-uk/1",
    component: CTReadingIncorrectUK1,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-reading-incorrect-uk/2",
    component: CTReadingIncorrectUK2,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-reading-incorrect-uk/3",
    component: CTReadingIncorrectUK3,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
  {
    path: "/commission/error/ct-reading-incorrect-uk/4",
    component: CTReadingIncorrectUK4,
    meta: { requiresAuth: true, requiresSerialNumber: true },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  // login guard
  const shouldLogin =
    to.matched.some((record) => record.meta.requiresAuth) &&
    !store.getters.isLoggedIn;

  if (shouldLogin) {
    return next({ path: "/login" });
  }

  // address guard
  const shouldHaveAddress =
    to.matched.some((record) => record.meta.requiresAddress) &&
    !store.state.project.address?.address;

  if (shouldHaveAddress) {
    return next({ path: "/my-sites" });
  }

  // serial number guard
  const shouldHaveSerialNumber =
    to.matched.some((record) => record.meta.requiresSerialNumber) &&
    store.state.project.serialNumber === "";

  if (shouldHaveSerialNumber) {
    return next({ path: "/commission/2" });
  }

  // Wi-Fi polling guard
  const shouldShowIcon =
    to.matched.some((record) => record.meta.showWifiIcon) &&
    store.state.project.serialNumber !== "";

  if (shouldShowIcon) {
    if (!store.state.showWifiIcon) {
      store.commit("setWifiIcon", true);
    }
    // after page refresh, will need to set timer again
    if (store.state.wifiIntervalID === null) {
      store.dispatch("startPollingWifiConnection");
    }
  } else {
    if (store.state.showWifiIcon) {
      store.commit("setWifiIcon", false);
    }
    if (store.state.wifiIntervalID !== null) {
      store.dispatch("stopPollingWifiConnection");
    }
  }
  next();
});

router.onError((err) => console.log(err));

export default router;
